import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlayCircle, faPauseCircle } from "@fortawesome/free-solid-svg-icons";
import "./webzoomcoloraudio.css";


function WebZoomColorAudio() {
    const audioplay = <FontAwesomeIcon icon={faPlayCircle} />
    const audiopause = <FontAwesomeIcon icon={faPauseCircle} />


    // ........................react code start

    const fontChangeLevel = useRef(0); // Track level of change (from -3 to +3)

  // Apply font size changes to all text elements
  const applyFontChange = (level) => {
    const elements = document.querySelectorAll("body *"); // all elements inside body

    elements.forEach((el) => {
      // Skip empty or invisible text elements
      if (!el.textContent.trim()) return;

      const style = window.getComputedStyle(el);
      const currentSize = parseFloat(style.fontSize);

      // Store the original base size once
      if (!el.dataset.baseFontSize) {
        el.dataset.baseFontSize = currentSize;
      }

      // Calculate new size
      const newSize = parseFloat(el.dataset.baseFontSize) + level;
      el.style.fontSize = `${newSize}px`;
    });
  };

  // Increase font size (max +3)
  const handleIncreaseFont = () => {
    if (fontChangeLevel.current < 3) {
      fontChangeLevel.current += 1;
      applyFontChange(fontChangeLevel.current);
    }
  };

  // Decrease font size (max -3)
  const handleDecreaseFont = () => {
    if (fontChangeLevel.current > -3) {
      fontChangeLevel.current -= 1;
      applyFontChange(fontChangeLevel.current);
    }
  };

  // Reset font size (remove inline styles)
  const handleResetFont = () => {
    fontChangeLevel.current = 0;
    const elements = document.querySelectorAll("body *");
    elements.forEach((el) => {
      el.style.fontSize = "";
      delete el.dataset.baseFontSize;
    });
  };


// ...............................bg-color-start
// List of all background classes
  const bgClasses = ["darkbg1", "yellowbg1", "bluebg1", "orangebg1", "whitebg1"];

  // Function to apply a specific background class
  const handleSetBackground = (className) => {
    const elements = document.querySelectorAll("body *"); // all elements inside body

    elements.forEach((el) => {
      // Only elements with text or visible background
      const style = window.getComputedStyle(el);
      const hasText = el.textContent.trim() !== "";
      const hasBackground = style.backgroundColor && style.backgroundColor !== "rgba(0, 0, 0, 0)" && style.backgroundColor !== "transparent";

      if (hasText || hasBackground) {
        // Remove all bg classes first
        bgClasses.forEach((cls) => el.classList.remove(cls));

        // Add the selected class if not reset
        if (className) el.classList.add(className);
      }
    });
  };

  // Reset / remove all classes
  const handleResetBackground = () => {
    handleSetBackground(null);
  };


  // ...............................Text-to-speech
  const [isSpeaking, setIsSpeaking] = useState(false);

  const handlePlay = () => {
    const synth = window.speechSynthesis;

    // Stop if already speaking
    if (synth.speaking) synth.cancel();

    // Get all visible page text
    const text = document.body.innerText;
    if (!text.trim()) return;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-IN"; // Set your preferred language (e.g., "hi-IN" for Hindi)
    utterance.rate = 1; // 0.5 (slow) to 2 (fast)
    utterance.pitch = 1;

    utterance.onend = () => setIsSpeaking(false);

    synth.speak(utterance);
    setIsSpeaking(true);
  };

  const handlePause = () => {
    const synth = window.speechSynthesis;
    if (synth.speaking) {
      synth.cancel(); // stop immediately
      setIsSpeaking(false);
    }
  };


    return (
        <div className="zoomcoloraudio-section">
            <div class="container">
            <ul className="zoomcoloraudio-list">
                <li>
        <span
          id="mnskhincfont"
          title="Increase Font"
          className="fontincreasefont"
          onClick={handleIncreaseFont}
        >
          (A)+
        </span>
      </li>
      <li>
        <span
          id="mnskhresetfont"
          title="Reset Font"
          className="fontreset"
          onClick={handleResetFont}
        >
          (A)
        </span>
      </li>
      <li>
        <span
          id="mnskhdecfont"
          title="Decrease Font"
          className="fontdecreasefont"
          onClick={handleDecreaseFont}
        >
          (A)-
        </span>
      </li>
              
       <li>
        <span
          className="mnskhdsitebg darkbg text-white"
          title="Dark Font"
          onClick={() => handleSetBackground("darkbg1")}
        >
        A
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg whitebg"
          title="Light Font"
          onClick={handleResetBackground}
        >
        A
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg yellowbg"
        
          title="Yellow Font"
          onClick={() => handleSetBackground("yellowbg1")}
        >
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg bluebg"
        
          title="Blue Font"
          onClick={() => handleSetBackground("bluebg1")}
        >
          
        </span>
      </li>
      <li>
        <span
          className="mnskhdsitebg orangebg"
        
          title="Orange Font"
          onClick={() => handleSetBackground("orangebg1")}
        >
         
        </span>
      </li>
      <li className="audioplaypause">
            {!isSpeaking ? (
              <span
                className="audioplaypause-btn"
                title="Play Button"
                onClick={handlePlay}
              >
             {audioplay}
              </span>
            ) : (
              <span
                className="audioplaypause-btn"
                title="Pause Button"
                onClick={handlePause}
              >
               {audiopause}
              </span>
            )}
          </li>
                {/* <li className="audioplaypause">
                    <span class="audioplaypause-btn" title="Play Button">{audioplay}</span>
                    <span class="audioplaypause-btn" title="Pause Button">{audiopause}</span>
                </li> */}
            </ul>
            </div>
        </div>
    );
}
export default WebZoomColorAudio;
